import dmItem from "./inbox.item.dm";
import kpItem from "./inbox.item.kp";
import issue1 from "./inbox.item.issue1";
import forum from "./inbox.item.forum";
import forum1 from "./inbox.item.forum1";
import forum2 from "./inbox.item.forum2";
import important from "./inbox.item.important";
export default [dmItem, important, kpItem, issue1, forum, forum1, forum2];